import { useAppSelector } from '~/redux/hooks'
import { Tab } from '~/settings-scenario/types'
import { Breakpoint, useScreenBreakPoints } from '~/utils'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import HomRightArrowIcon from '~/components/Icons/svgs/HomRightArrowIcon'
import { selectTab } from '~/settings-scenario/redux/settings.slice'

export function TabItem({
  name,
  tab,
  onTabChange,
}: {
  name: string
  tab: Tab
  onTabChange(tab: Tab, logEventSettings?: string): void
}): React.ReactElement {
  const isSmallScreen = useScreenBreakPoints({ lt: Breakpoint.XL })
  const currTab = useAppSelector(selectTab)
  const isActiveClass = isSmallScreen ? 'text-black-link' : currTab === tab ? 'text-purple' : 'text-black-link'
  const hoverClass = isSmallScreen ? 'text-black-link' : 'text-purple'

  return (
    <div
      className={`cursor-pointer flex hover:${hoverClass} ${isActiveClass}`}
      onClick={() => onTabChange(tab)}
      onKeyDown={(event) => event.key === 'Enter' && onTabChange(tab)}
      tabIndex={0}
    >
      <div className="mt-1">
        <li className={`cursor-pointer text-sm md:text-md hover:${hoverClass} ${isActiveClass}`}>{name}</li>
      </div>

      {isSmallScreen && (
        <div className="font-normal flex ml-auto">
          <SVGIcon icon={HomRightArrowIcon} pathClassName="text-black" />
        </div>
      )}
    </div>
  )
}
